module.exports = __webpack_public_path__ + "img/google-play.7a2c2ed0.png";